export class LastViewedVehicle {
    setLastViewedVehicle = (id) => {
        localStorage.setItem('lastViewedVehicle', id);
    };
    getLastViewedVehicle = () => {
        return localStorage.getItem('lastViewedVehicle');
    };
}

const lastViewedNode = document.getElementById('saveLastViewed');
if (lastViewedNode !== null) {
    const id = lastViewedNode.dataset.vehicleId;
    const lastViewed = new LastViewedVehicle();

    lastViewed.setLastViewedVehicle(id);
}
